import { Route } from 'react-router-dom';
import { RecommendRuleList } from './rule/list';

export const RecommendRoute = (
  <Route path="recommend">
    <Route path="rules">
      <Route index element={<RecommendRuleList />} />
    </Route>
    {/*<Route path="items">*/}
    {/*  <Route index element={<RecommendItemList />} />*/}
    {/*</Route>*/}
  </Route>
);
